import React from 'react';

import { IFilterSelection } from 'utils/memberFilters';
import { ActiveFilters } from 'views/components/ActiveFilters';

export interface FilterItemType {
  name: string;
  stateKey: string;
  filterSelections: IFilterSelection[];
  setFilterSelections: (filterSelections: IFilterSelection[]) => void;
}

interface IFilterByCategoriesProps {
  filters: FilterItemType[];
  className?: string;
}

const getChipLabel = (filter: FilterItemType, selection: IFilterSelection): string =>
  filter.name === 'unit'
    ? selection.label.replace(/^(.+?)\s+—\s+(.+)$/, '$1 ($2)')
    : selection.label;

const FilterByCategories = ({
  filters,
  className,
}: IFilterByCategoriesProps): React.ReactElement => {
  const onRemoveAllFilters = (): void => {
    filters.forEach(filter => filter.setFilterSelections([]));
  };

  const handleFilterDelete = (
    selectionId: IFilterSelection['id'],
    filter: FilterItemType,
  ): void => {
    const updatedFilters = filter.filterSelections.filter(
      selection => selection.id !== selectionId,
    );
    filter.setFilterSelections(updatedFilters);
  };

  return (
    <ActiveFilters
      filters={filters.flatMap(filter =>
        filter.filterSelections.map(selection => ({
          id: `${filter.stateKey}-${selection.id}`,
          label: getChipLabel(filter, selection),
          onRemove: () => handleFilterDelete(selection.id, filter),
        })),
      )}
      onClearAll={onRemoveAllFilters}
      className={className}
    />
  );
};

export { FilterByCategories };
